import { CatalogDependenciesObjectConverter } from './catalog.dependencies.converter';
import { isNullOrUndefined } from 'util';
import { CatalogCharacteristicsObjectConverter } from './catalog.characteristics.converter';
import { CatalogInfoObject } from '../../../models/catalog/catalog-info-object.model';
import { Injectable } from '@angular/core';
import { CatalogCharacteristicObject } from '../../../models/catalog/catalog-characteristic-object.model';
import { Converter } from '../converter.interface';

@Injectable({
    providedIn: 'root'
})

export class CatalogInfoObjectConverter implements Converter<CatalogInfoObject> {

    constructor(private characteristicsConverter: CatalogCharacteristicsObjectConverter,
        private dependenciesConverter: CatalogDependenciesObjectConverter) { }

    convert(input: any): CatalogInfoObject {
        const characteristics = new Array<CatalogCharacteristicObject>();

        if (isNullOrUndefined(input)) {
            return CatalogInfoObject.create();
        }

        input.characteristics.forEach(element => {
            const characteristic = this.characteristicsConverter.convert(element);
            characteristics.push(characteristic);
        });

        const dependencies = this.dependenciesConverter.convert(input.dependencies);

        return new CatalogInfoObject(characteristics, dependencies);
    }

}
